import config from "@/config";
import moment from "moment";

const { intercomMessengerId } = config;

type TrackFirstTimeEventOptions = {
  eventName: string;
  user: {
    id: string;
    email?: string;
    name?: string;
  };
  properties?: Record<string, any>;
  storage?: "localStorage" | "sessionStorage";
};

export const trackFirstTimeIntercomEvent = ({
  eventName,
  user,
  properties = {},
  storage = "localStorage",
}: TrackFirstTimeEventOptions) => {
  try {
    if (typeof window === "undefined") return;

    const IntercomFn = (window as any).Intercom;

    if (typeof IntercomFn !== "function") {
      console.warn("Intercom not available");
      return;
    }

    if (!user?.id) {
      console.warn("User ID missing for Intercom tracking");
      return;
    }

    const store =
      storage === "sessionStorage"
        ? window.sessionStorage
        : window.localStorage;

    const storageKey = `intercom_first_time_${eventName}_${user.id}`;

    if (store.getItem(storageKey)) {
      return;
    }

    IntercomFn("update", {
      app_id: intercomMessengerId,
      user_id: user.id,
      email: user.email,
      name: user.name,
    });

    let momentdate = moment(new Date().toISOString());
    let date = momentdate?.format("DD/MM/YYYY HH:mm");

    IntercomFn("trackEvent", eventName, {
      ...properties,
      triggered_at: date,
    });

    store.setItem(storageKey, "true");
  } catch (error) {
    console.error("Failed to track Intercom first-time event", error);
  }
};
